function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 3,
  y: 4,
  width: 18,
  height: 16,
  rx: 2
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15 4v16"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7 12h4"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M9 10l2 2 -2 2"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/dock-right.d2718898.svg";
export { SvgComponent as ReactComponent };